(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["instant_app_swatch"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__instandSwatchesInitialized) return;
    window.__instandSwatchesInitialized = true;

    var productCache = {};
    var fetchPromises = {};

    function getAllSwatchHandles() {
      var swatches = document.querySelectorAll('.instand_swatch__item[data-handle]');
      var handles = [];
      swatches.forEach(function(swatch) {
        var handle = swatch.getAttribute('data-handle');
        if (handle && handles.indexOf(handle) === -1) {
          handles.push(handle);
        }
      });
      return handles;
    }

    async function fetchProduct(handle) {
      // If we already have the product in cache, return it
      if (productCache[handle]) {
        return productCache[handle];
      }

      // If a fetch for this handle is already in progress, return the promise
      if (fetchPromises[handle]) {
        return fetchPromises[handle];
      }

      // Otherwise, start a new fetch
      var promise = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Failed to load product data for handle: ' + handle);
          }
          return response.json();
        })
        .then(function(product) {
          productCache[handle] = product;

          // Preload the main image so it’s faster when we swap src
          if (product.featured_image) {
            var img = new Image();
            img.src = product.featured_image;
          }

          return product;
        })
        .catch(function(error) {
          console.error(error);
          throw error;
        })
        .finally(function() {
          // cleanup
          delete fetchPromises[handle];
        });

      fetchPromises[handle] = promise;
      return promise;
    }

    // Preload ALL swatch products + images as soon as possible
    function preloadAllSwatchProducts() {
      var handles = getAllSwatchHandles();
      handles.forEach(function(handle) {  fetchProduct(handle).catch(function(error) {  console.error(error); });
      });
    }

    function updateProductCard(root, product, target) {
      var closest_div = target.closest('[data-instant-type="container"]');
      if (!closest_div) return;

      // Optional: show loading state (very quick now)
      closest_div.classList.add('is-loading-image');

      var titleEl = closest_div.querySelector('[data-instant-type="container"] h3');
      var priceEl = closest_div.querySelector('[data-instant-dynamic-content-source="PRICE"]');
      var imageEl = closest_div.querySelector('[data-instant-type="image"] img');

      // Update image from cached product data (the image should already be cached by the browser)
      if (imageEl && product.featured_image) {
        // Clear srcset to avoid conflicts with old sizes
        imageEl.srcset = '';
        imageEl.src = product.featured_image;

        if (product.title) {
          imageEl.alt = product.title;
        }

        // Once the image src changes, wait for it to load (usually very fast from cache)
        imageEl.onload = function() {
          closest_div.classList.remove('is-loading-image');
        };
      } else {
        closest_div.classList.remove('is-loading-image');
      }

      // Update title
      if (titleEl) {
        titleEl.textContent = product.title;
      }

      // Update the container with the new product URL
      if (product.url) {
        closest_div.setAttribute('data-instant-form-product-url', product.url);
      }

      // Update price (raw number from AJAX API is in cents)
      if (priceEl && typeof product.price === 'number') {
        priceEl.innerHTML = '<span class="money">' + (product.price / 100) + '</span>';
      }

      // Re-run Doubly currency converter if present
      setTimeout(function() {
        if (window.DoublyGlobalCurrency && DoublyGlobalCurrency.convertAll) {
          DoublyGlobalCurrency.convertAll();
        }
      }, 200);
      
      target.closest('.instand_swatch').querySelectorAll('button').forEach(e => e.classList.remove('active'));
      target.closest('button').classList.add('active');
    }

    // Preload as soon as DOM is ready
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', preloadAllSwatchProducts); } else {  preloadAllSwatchProducts(); }

    // On click: use cached product (or fall back to fetch if needed)
    document.addEventListener('click', function(event) {
      var target = event.target;  if (!target.closest) return;
      var swatchButton = target.closest('.instand_swatch__item');
      if (!swatchButton) return;
      var handle = swatchButton.getAttribute('data-handle');
      if (!handle) return;
      var productCardRoot =  swatchButton.closest('[data-product-card]') ||  swatchButton.closest('[data-product]') ||   document;
      fetchProduct(handle)
        .then(function(product) { updateProductCard(productCardRoot, product, target); })
        .catch(function(error) { console.error(error); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
